// Rich-text fields can hold "empty" content that isn't an empty string, e.g. an editor
// saving "<p><br></p>" or "&nbsp;" for a field the user cleared. Treat that the same as
// null/undefined/"" so buttons and sheets for genuinely empty content stay hidden.
export const isBlank = (value?: string | null) => {
  if (!value) return true
  return !value
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, "")
    .trim()
}

// Type-guard flavour of `isBlank` so a single check both hides the button and narrows the
// field to `string` for the sheet's props.
export const hasContent = (value?: string | null): value is string =>
  !isBlank(value)
